var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "download-task-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix header-actions",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "header-left" }, [
                _c("div", { staticClass: "page-title-wrapper" }, [
                  _c("div", { staticClass: "page-icon" }, [
                    _c("i", { staticClass: "el-icon-document-copy" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "page-title-content" }, [
                    _c("span", { staticClass: "page-title" }, [
                      _vm._v("导出任务管理"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "page-subtitle" }, [
                      _vm._v("管理您的所有导出任务"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-right" },
                [
                  _vm.selectedTasks.length > 0
                    ? _c(
                        "el-button",
                        {
                          staticClass: "batch-delete-btn",
                          attrs: {
                            type: "danger",
                            size: "small",
                            icon: "el-icon-delete",
                          },
                          on: { click: _vm.handleBatchDelete },
                        },
                        [
                          _vm._v(
                            "\n          批量删除 (" +
                              _vm._s(_vm.selectedTasks.length) +
                              ")\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "warning",
                        size: "small",
                        icon: "el-icon-brush",
                        loading: _vm.cleaningLoading,
                        plain: "",
                      },
                      on: { click: _vm.handleCleanExpired },
                    },
                    [_vm._v("\n          清理过期\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    { attrs: { content: "刷新数据", placement: "bottom" } },
                    [
                      _c("el-button", {
                        attrs: {
                          size: "small",
                          icon: "el-icon-refresh",
                          circle: "",
                        },
                        on: { click: _vm.refreshAll },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isAdmin
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "管理员中止所有执行中的任务",
                            placement: "bottom",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "el-icon-video-pause",
                                loading: _vm.adminStopAllLoading,
                                plain: "",
                              },
                              on: { click: _vm.handleAdminStopAll },
                            },
                            [_vm._v("\n            全部中止\n          ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "statistics-cards" },
            _vm._l(_vm.statisticsCards, function (card) {
              return _c(
                "div",
                {
                  key: card.type,
                  staticClass: "stat-card",
                  class: [
                    "stat-card-" + card.type,
                    {
                      active: _vm.filterForm.status === card.filterStatus,
                      pulse: card.count > 0 && card.type === "processing",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.handleStatusFilter(card.filterStatus)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "stat-glow" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-icon-wrapper" }, [
                    _c("div", { staticClass: "stat-icon" }, [
                      _c("i", { class: card.icon }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-info" }, [
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(_vm._s(card.count)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v(_vm._s(card.label)),
                    ]),
                  ]),
                  _vm._v(" "),
                  card.trend
                    ? _c("div", { staticClass: "stat-trend" }, [
                        _c("i", {
                          class:
                            card.trend > 0 ? "el-icon-top" : "el-icon-bottom",
                        }),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _vm.showQueueDetailCard
              ? _c("div", { staticClass: "queue-detail-card" }, [
                  _c(
                    "div",
                    { staticClass: "queue-card-header" },
                    [
                      _c(
                        "div",
                        { staticClass: "header-left" },
                        [
                          _c("span", { staticClass: "queue-card-title" }, [
                            _c("i", { staticClass: "el-icon-s-data" }),
                            _vm._v("\n              导出队列\n            "),
                          ]),
                          _vm._v(" "),
                          _vm.currentQueueInfo.hasProcessing ||
                          _vm.currentQueueInfo.waitingCount > 0
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "queue-badge",
                                  attrs: {
                                    size: "mini",
                                    type: "warning",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-bell" }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        (_vm.currentQueueInfo.processingTasks &&
                                          _vm.currentQueueInfo.processingTasks
                                            .length) ||
                                          0
                                      ) +
                                      " 执行中 · " +
                                      _vm._s(
                                        _vm.currentQueueInfo.waitingCount
                                      ) +
                                      " 排队中\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tabs",
                        {
                          staticClass: "queue-type-tabs",
                          on: { "tab-click": _vm.handleQueueTypeChange },
                          model: {
                            value: _vm.queueTaskType,
                            callback: function ($$v) {
                              _vm.queueTaskType = $$v
                            },
                            expression: "queueTaskType",
                          },
                        },
                        [
                          _c("el-tab-pane", {
                            attrs: {
                              label: "订单导出",
                              name: "FAST_ORDER_EXPORT",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-tab-pane", {
                            attrs: { label: "结果导出", name: "ORDER_EXPORT" },
                          }),
                          _vm._v(" "),
                          _c("el-tab-pane", {
                            attrs: {
                              label: "线下订单",
                              name: "OFFLINE_ORDER_EXPORT",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "close-btn",
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.showQueueDetailCard = false
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-minus" })]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "queue-card-content" },
                    [
                      _c(
                        "transition-group",
                        {
                          staticClass: "queue-list",
                          attrs: { name: "task-list", tag: "div" },
                        },
                        [
                          _vm._l(
                            _vm.currentQueueInfo.processingTasks,
                            function (task) {
                              return _c(
                                "div",
                                {
                                  key: task.taskId,
                                  staticClass: "queue-item processing-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "queue-item-icon processing-icon",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-loading",
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "pulse-ring" }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "queue-item-content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "queue-item-header" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "task-type-display",
                                            },
                                            [_vm._v(_vm._s(task.taskTypeName))]
                                          ),
                                          _vm._v(" "),
                                          task.progress
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "task-progress-badge",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(task.progress) +
                                                      "%\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "queue-item-meta" },
                                        [
                                          task.userName
                                            ? _c(
                                                "span",
                                                { staticClass: "owner-badge" },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-user",
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(task.userName) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          task.taskId
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "task-id-badge",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyTaskId(
                                                        task.taskId
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    ID: " +
                                                      _vm._s(
                                                        _vm.formatTaskId(
                                                          task.taskId
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-document-copy",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      task.startTime
                                        ? _c(
                                            "div",
                                            { staticClass: "queue-item-time" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-timer",
                                              }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.formatDisplayTime(
                                                      task.startTime
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              task.estimatedRemainingSeconds
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "remain-time",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    · 剩余约 " +
                                                          _vm._s(
                                                            _vm.formatWaitTime(
                                                              task.estimatedRemainingSeconds
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("el-progress", {
                                        staticClass: "task-progress-bar",
                                        attrs: {
                                          percentage: task.progress || 0,
                                          "stroke-width": 6,
                                          "show-text": false,
                                          color: _vm.progressColors,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "queue-item-status" },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "executing-tag",
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            effect: "dark",
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "dot-animation",
                                          }),
                                          _vm._v(
                                            "\n                  执行中\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "queue-item-actions" },
                                    [
                                      _vm.isAdmin || task.isCurrentUser
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "cancel-btn",
                                              attrs: {
                                                size: "mini",
                                                type: "danger",
                                                icon: "el-icon-video-pause",
                                                loading: task.stopping,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleStopTaskFromQueue(
                                                    task
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.isAdmin &&
                                                      !task.isCurrentUser
                                                      ? "中止"
                                                      : "中止任务"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          !_vm.currentQueueInfo.processingTasks ||
                          _vm.currentQueueInfo.processingTasks.length === 0
                            ? _c(
                                "div",
                                { key: "empty", staticClass: "queue-empty" },
                                [
                                  _c("div", { staticClass: "empty-content" }, [
                                    _c(
                                      "div",
                                      { staticClass: "empty-icon-wrapper" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-check-circle",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("当前无导出任务正在执行"),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentQueueInfo.waitingTasks &&
                          _vm.currentQueueInfo.waitingTasks.length > 0
                            ? [
                                _c(
                                  "div",
                                  {
                                    key: "header",
                                    staticClass: "waiting-header",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "waiting-title" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-bottom",
                                        }),
                                        _vm._v(
                                          "\n                  排队中 (" +
                                            _vm._s(
                                              _vm.currentQueueInfo.waitingCount
                                            ) +
                                            ")\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "waiting-hint" },
                                      [
                                        _vm._v(
                                          "预计等待时间基于当前队列位置估算"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.currentQueueInfo.waitingTasks,
                                  function (task) {
                                    return _c(
                                      "div",
                                      {
                                        key: task.taskId,
                                        staticClass: "queue-item waiting-item",
                                        class: {
                                          "is-mine": task.isCurrentUser,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "queue-item-icon waiting-icon",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "queue-position" },
                                              [
                                                _vm._v(
                                                  _vm._s(task.queuePosition)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "queue-item-content" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "queue-item-header",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "task-type-display",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(task.taskTypeName)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "queue-item-meta",
                                              },
                                              [
                                                task.userName
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "owner-badge",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-user",
                                                        }),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              task.userName
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                task.taskId
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "task-id-badge",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.copyTaskId(
                                                              task.taskId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      ID: " +
                                                            _vm._s(
                                                              _vm.formatTaskId(
                                                                task.taskId
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-document-copy",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            task.joinTime
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "queue-item-time",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-timer",
                                                    }),
                                                    _vm._v(
                                                      "\n                    入队 " +
                                                        _vm._s(
                                                          _vm.formatDisplayTime(
                                                            task.joinTime
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                    task.estimatedWaitSeconds
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "wait-time",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      · 预计等待 " +
                                                                _vm._s(
                                                                  _vm.formatWaitTime(
                                                                    task.estimatedWaitSeconds
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "queue-item-status" },
                                          [
                                            task.isCurrentUser
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "danger",
                                                      effect: "dark",
                                                    },
                                                  },
                                                  [_vm._v("我的任务")]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "queue-position-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "第 " +
                                                        _vm._s(
                                                          task.queuePosition
                                                        ) +
                                                        " 位"
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          !_vm.showQueueDetailCard
            ? _c(
                "div",
                {
                  staticClass: "show-queue-btn",
                  on: {
                    click: function ($event) {
                      _vm.showQueueDetailCard = true
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-arrow-up" }),
                  _vm._v("\n      显示导出队列\n      "),
                  _vm.currentQueueInfo.waitingCount > 0
                    ? _c("el-badge", {
                        staticClass: "queue-badge",
                        attrs: {
                          value: _vm.currentQueueInfo.waitingCount,
                          max: 99,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-section" },
            [
              _c(
                "el-form",
                {
                  staticClass: "filter-form",
                  attrs: {
                    inline: true,
                    model: _vm.filterForm,
                    size: "small",
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-select",
                          attrs: { placeholder: "全部状态", clearable: "" },
                          on: { change: _vm.handleFilterChange },
                          model: {
                            value: _vm.filterForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterForm, "status", $$v)
                            },
                            expression: "filterForm.status",
                          },
                        },
                        _vm._l(_vm.statusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-select",
                          attrs: { placeholder: "全部类型", clearable: "" },
                          on: { change: _vm.handleFilterChange },
                          model: {
                            value: _vm.filterForm.taskType,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterForm, "taskType", $$v)
                            },
                            expression: "filterForm.taskType",
                          },
                        },
                        _vm._l(_vm.taskTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关键词" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "filter-input",
                          attrs: { placeholder: "任务名称", clearable: "" },
                          on: { clear: _vm.handleFilterChange },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleFilterChange($event)
                            },
                          },
                          model: {
                            value: _vm.filterForm.taskName,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterForm, "taskName", $$v)
                            },
                            expression: "filterForm.taskName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            on: { click: _vm.handleFilterChange },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "filter-date-range",
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        on: { change: _vm.handleDateRangeChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilterChange },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "reset-btn",
                          attrs: { icon: "el-icon-refresh" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.taskList,
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#606266",
                  fontWeight: "bold",
                },
                "row-key": function (row) {
                  return row.id || row.taskName
                },
                "row-class-name": _vm.tableRowClassName,
                stripe: "",
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "50", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taskName",
                  label: "任务信息",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "task-name-cell" }, [
                          _c("div", { staticClass: "task-name-main" }, [
                            _c("span", { staticClass: "task-name" }, [
                              _vm._v(_vm._s(scope.row.taskName)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "task-id-small",
                                attrs: { title: "点击复制ID" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyTaskId(scope.row.id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                #" +
                                    _vm._s(scope.row.id) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "task-meta" },
                            [
                              _c(
                                "el-tag",
                                {
                                  staticClass: "task-type-tag",
                                  attrs: {
                                    size: "mini",
                                    type: _vm.getStatusTagType(
                                      scope.row.status
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(scope.row.taskTypeName) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getStatusTagType(scope.row.status),
                                  size: "small",
                                  effect: "dark",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.statusName) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            scope.row.status === "PROCESSING"
                              ? _c("span", { staticClass: "progress-text" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.progress) +
                                      "%\n            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status === "WAITING"
                              ? _c("span", { staticClass: "queue-text" }, [
                                  _vm._v(
                                    "\n              第 " +
                                      _vm._s(scope.row.queuePosition || "-") +
                                      " 位\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "进度", width: "180", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === "PROCESSING"
                          ? _c(
                              "div",
                              { staticClass: "progress-cell" },
                              [
                                _c("el-progress", {
                                  attrs: {
                                    percentage: scope.row.progress || 0,
                                    "stroke-width": 8,
                                    color: _vm.progressColors,
                                  },
                                }),
                              ],
                              1
                            )
                          : scope.row.status === "WAITING"
                          ? _c("div", { staticClass: "progress-waiting" }, [
                              _c("div", { staticClass: "waiting-indicator" }, [
                                _c("i", { staticClass: "el-icon-refresh" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("排队等待")]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "waiting-position" }, [
                                _vm._v(
                                  "\n              前方任务完成后自动开始\n            "
                                ),
                              ]),
                            ])
                          : scope.row.status === "COMPLETED"
                          ? _c("div", { staticClass: "progress-complete" }, [
                              _c("i", { staticClass: "el-icon-check-circle" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("已完成")]),
                            ])
                          : scope.row.status === "FAILED"
                          ? _c("div", { staticClass: "progress-failed" }, [
                              _c("i", {
                                staticClass: "el-icon-warning-circle",
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("执行失败")]),
                            ])
                          : scope.row.status === "CANCELLED"
                          ? _c("div", { staticClass: "progress-cancelled" }, [
                              _c("i", { staticClass: "el-icon-video-pause" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("已中止")]),
                            ])
                          : _c("div", { staticClass: "progress-pending" }, [
                              _c("i", { staticClass: "el-icon-time" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("等待中")]),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fileName",
                  label: "文件信息",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.fileName
                          ? _c("div", { staticClass: "file-info-cell" }, [
                              _c("div", { staticClass: "file-icon" }, [
                                _c("i", { staticClass: "el-icon-document" }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "file-details" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "file-name",
                                    attrs: { title: scope.row.fileName },
                                  },
                                  [_vm._v(_vm._s(scope.row.fileName))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "file-size" }, [
                                  _vm._v(_vm._s(scope.row.fileSizeStr)),
                                ]),
                              ]),
                            ])
                          : _c("div", { staticClass: "file-empty" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "exportConditionSummary",
                  label: "导出条件",
                  "min-width": "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.exportConditionSummary &&
                        scope.row.exportConditionSummary !== "-"
                          ? _c(
                              "div",
                              { staticClass: "condition-cell" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: scope.row.exportConditionSummary,
                                      placement: "top",
                                      "open-delay": 300,
                                      disabled:
                                        scope.row.exportConditionSummary
                                          .length < 30,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "condition-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.exportConditionSummary
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("div", { staticClass: "condition-empty" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "duration",
                  label: "耗时",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.duration
                          ? _c("span", { staticClass: "duration-text" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.formatDuration(scope.row.duration)
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _c("span", { staticClass: "duration-empty" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  width: "160",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "time-cell" }, [
                          _c("i", { staticClass: "el-icon-time" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(scope.row.createTime))
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "剩余有效期", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === "COMPLETED" && scope.row.expireTime
                          ? _c(
                              "span",
                              {
                                class: [
                                  "expire-text",
                                  {
                                    "expire-soon": _vm.isExpireSoon(
                                      scope.row.expireTime
                                    ),
                                    "expire-warning": _vm.isExpireWarning(
                                      scope.row.expireTime
                                    ),
                                  },
                                ],
                              },
                              [
                                _c("i", {
                                  class: _vm.isExpireSoon(scope.row.expireTime)
                                    ? "el-icon-bell"
                                    : "el-icon-alarm-clock",
                                }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.formatExpireTime(scope.row.expireTime)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _c("span", { staticClass: "expire-empty" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "280",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            scope.row.status === "WAITING"
                              ? [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "刷新状态",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          icon: "el-icon-refresh",
                                          loading: scope.row.refreshing,
                                          disabled: scope.row.refreshing,
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRefreshStatus(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "取消排队",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          icon: "el-icon-close",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleCancelQueue(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : scope.row.status === "PROCESSING"
                              ? [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "刷新状态",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          icon: scope.row.refreshing
                                            ? "el-icon-loading"
                                            : "el-icon-refresh",
                                          loading: scope.row.refreshing,
                                          disabled: scope.row.refreshing,
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRefreshStatus(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "中止导出",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          icon: "el-icon-video-pause",
                                          loading: scope.row.stopping,
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleStopTask(scope.row)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : scope.row.status === "COMPLETED"
                              ? [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "下载文件",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                          icon: "el-icon-download",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDownload(scope.row)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : scope.row.status === "FAILED"
                              ? [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          scope.row.errorMessage || "查看错误",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "warning",
                                          size: "mini",
                                          icon: "el-icon-warning",
                                          circle: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-popconfirm",
                              {
                                attrs: {
                                  title:
                                    "确定删除任务「" +
                                    scope.row.taskName +
                                    "」吗？",
                                  "confirm-button-text": "确定",
                                  "cancel-button-text": "取消",
                                  icon: "el-icon-info",
                                  "icon-color": "#f56c6c",
                                },
                                on: {
                                  onConfirm: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      content: "删除任务",
                                      placement: "top",
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "info",
                                        size: "mini",
                                        icon: "el-icon-delete",
                                        circle: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pagination.limit,
                  total: _vm.pagination.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.listLoading && _vm.taskList.length === 0
          ? _c("div", { staticClass: "empty-state" }, [
              _c(
                "div",
                { staticClass: "empty-content" },
                [
                  _c("div", { staticClass: "empty-illustration" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "empty-svg",
                        attrs: { viewBox: "0 0 200 200" },
                      },
                      [
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "emptyGrad",
                                  x1: "0%",
                                  y1: "0%",
                                  x2: "100%",
                                  y2: "100%",
                                },
                              },
                              [
                                _c("stop", {
                                  staticStyle: { "stop-color": "#f5f7fa" },
                                  attrs: { offset: "0%" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  staticStyle: { "stop-color": "#e4e7ed" },
                                  attrs: { offset: "100%" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: "100",
                            cy: "100",
                            r: "80",
                            fill: "url(#emptyGrad)",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M70 80 L130 80 L130 140 L70 140 Z",
                            fill: "#fff",
                            stroke: "#dcdfe6",
                            "stroke-width": "2",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M80 95 L120 95",
                            stroke: "#409eff",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M80 110 L110 110",
                            stroke: "#67c23a",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M80 125 L100 125",
                            stroke: "#e6a23c",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "empty-text" }, [
                    _vm._v("暂无导出任务"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "empty-hint" }, [
                    _vm._v("您还没有任何导出任务，开始导出订单数据吧"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "empty-btn",
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.goToExport },
                    },
                    [_vm._v("\n          前往导出\n        ")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "notify-slide" } }, [
        _vm.notification.show
          ? _c(
              "div",
              {
                staticClass: "notification-toast",
                class: "notification-" + _vm.notification.type,
              },
              [
                _c("div", { staticClass: "notification-icon" }, [
                  _c("i", {
                    class:
                      _vm.notification.type === "success"
                        ? "el-icon-check-circle"
                        : "el-icon-warning-circle",
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-content" }, [
                  _c("div", { staticClass: "notification-title" }, [
                    _vm._v(_vm._s(_vm.notification.title)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notification-message" }, [
                    _vm._v(_vm._s(_vm.notification.message)),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "notification-close",
                    on: {
                      click: function ($event) {
                        _vm.notification.show = false
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-close" })]
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-decoration" }, [
      _c("div", { staticClass: "bg-circle bg-circle-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "bg-circle bg-circle-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "bg-circle bg-circle-3" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }